<template>
  <div class="footer-info">
    <div class="footer-list">
      <div class="list-header">
        ABOUT.
      </div>
      <div class="list-body">
        <p>
          {{ $t('footer.name') }}
        </p>
        <p>
          {{ $t('footer.number') }}
        </p>
        <router-link to="/contact/terms">
          <p class="a">
            {{ $t('footer.PP') }}
          </p>
        </router-link>
        Copyright 2023. NANDSOFT Inc, All rights reserved.
      </div>
    </div>
    <div class="footer-list">
      <div class="list-header">
        CONTACT.
      </div>
      <div class="list-body">
        <p>
          {{ $t('footer.tel') }}
        </p>
        <p>
          {{ $t('footer.fax') }}
        </p>
        <p>
          {{ $t('footer.email', {account:'nandsoft', domain:'nandsoft.co.kr'}) }}
        </p>
      </div>
    </div>
    <div class="footer-list">
      <div class="list-header">
        OFFICE.
      </div>
      <div class="list-body">
        <p>
          {{ $t('footer.addressH') }}
        </p>
        <p>
          {{ $t('footer.addressB') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterList'
}
</script>
